const MIMETypes = {
  pdf: 'application/pdf',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

/**
 * Download `requestUrl` as `fileName`. Resolves to whether the download succeeded.
 *
 * The request skips the HTTP cache: an `<img>` showing the same URL caches the response
 * without CORS headers (S3 only sends them when the request carries `Origin`), and a
 * cross-origin request that reuses that entry fails with a CORS error.
 */
const blobDownload = async (
  requestUrl: string,
  fileName: string,
  downloadType?: string,
): Promise<boolean> => {
  try {
    /* eslint-disable-next-line compat/compat */
    const response = await fetch(requestUrl, { cache: 'no-store' });
    if (!response.ok) throw new Error(`Download failed with status ${response.status}`);
    const data = await response.blob();
    const pdfBlob = new Blob([data], {
      type: Object.keys(MIMETypes).find((type) => type === downloadType)
        ? MIMETypes[downloadType as keyof typeof MIMETypes]
        : downloadType,
    });
    const pdfBlobUrl = window.URL.createObjectURL(pdfBlob);
    const a = document.createElement('a');
    a.href = pdfBlobUrl;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(pdfBlobUrl);
    return true;
  } catch (e) {
    console.warn(e);
    return false;
  }
};

export { blobDownload };
